"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.Header = exports.MapContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.MapContainer = (0, styled_1.default)('div') `
  height: 200px;
`;
exports.Header = (0, styled_1.default)('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    justify-content: flex-end;
  }

  button {
    padding-right: 0;
    padding-left: 0;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
  h5 {
    margin: 0;
    padding: 0;
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  }
`;
exports.Body = (0, styled_1.default)('div') `
  border: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: 2px;
`;
//# sourceMappingURL=styles.js.map